import React, {
  useEffect,
  useState,
} from "react";

import jwt_decode from "jwt-decode";

import {
  FaMoneyBillWave,
} from "react-icons/fa";

import AddCaja from "../components/AddCaja";
import TableCajas from "../components/TableCajas";
import Footer from "../components/Footer";

import "../css/admin.css";
import "../css/cajas.css";

const Cajas = () => {
  const [
    usuario,
    setUsuario,
  ] = useState({});

  const [
    show,
    setShow,
  ] = useState(false);

  const token =
    localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode =
          jwt_decode(token);

        setUsuario(
          token_decode.usuario
        );
      } catch (e) {
        console.error(
          "❌ Error al decodificar token:",
          e
        );

        setUsuario({});
      }
    }
  }, [token]);

  return (
    <>
      <main className="caja2-page">
        {token ? (
          usuario?.role ===
          "ADMIN_ROLE" ? (
            <>
              <section className="caja2-header">
                <div className="caja2-header-icon">
                  <FaMoneyBillWave />
                </div>

                <div className="caja2-header-text">
                  <span>
                    TESORERÍA
                  </span>

                  <h1>
                    Gestión de Cajas
                  </h1>

                  <p>
                    Administración de cajas,
                    saldos iniciales y saldos
                    actuales del sistema.
                  </p>
                </div>
              </section>

              <div className="caja2-actions">
                <AddCaja
                  setShow={setShow}
                  show={show}
                />
              </div>

              {!show && (
                <TableCajas />
              )}
            </>
          ) : (
            <div
              className="alert alert-info"
              role="alert"
            >
              Lo sentimos, pero no tiene
              permisos para acceder a este
              contenido.
            </div>
          )
        ) : (
          <div
            className="alert alert-danger"
            role="alert"
          >
            No se encuentra logueado en la
            plataforma.
          </div>
        )}
      </main>

      <Footer />
    </>
  );
};

export default Cajas;